<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">가상계좌</h2>
                <div class="page-text grey--text text--darken-1 mt-1">나누리 캐시 교환권 구매에 사용될 가상계좌를 설정하실 수 있습니다.</div>
            </div>

            <v-divider class="d-md-none" />

            <template v-if="vaccount._id">
                <mypage-vaccount-view v-bind="{ vaccount }" />
            </template>
            <template v-else>
                <mypage-vaccount-none v-on="{ post }" />
            </template>
        </div>
        <common-loader v-bind="{ loading }" />
    </component>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CommonLoader from "@/components/common/common-loader.vue";
import MypageVaccountNone from "@/components/client/mypage/vaccount/mypage-vaccount-none.vue";
import MypageVaccountView from "@/components/client/mypage/vaccount/mypage-vaccount-view.vue";

export default {
    components: {
        CommonLoader,
        MypageVaccountNone,
        MypageVaccountView,
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapState("vaccount", { vaccount: "value" }),
        accessToken() {
            return this.$store.state.accessToken;
        },
        logoff() {
            return !this.accessToken;
        },
        template() {
            return () => import(`@/templates/${this.$theme.pages.mypage}`);
        },
    },
    methods: {
        ...mapActions("vaccount", { getVaccount: "get", postVaccount: "post" }),

        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await this.getVaccount();
            } finally {
                this.loading = false;
            }
        },

        async post() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await this.postVaccount();
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        if (this.logoff) {
            this.$router.push(`/login`);
            return;
        }

        this.init();
    },
};
</script>

<style lang="scss" scoped></style>
